module.exports = __webpack_public_path__ + "img/40_38_048_880.d0f4a56e.jpg";